import { render, staticRenderFns } from "./Boxplot.vue?vue&type=template&id=f57e9228"
import script from "./Boxplot.vue?vue&type=script&lang=js"
export * from "./Boxplot.vue?vue&type=script&lang=js"
import style0 from "./Boxplot.vue?vue&type=style&index=0&id=f57e9228&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports